import React from 'react'
import PropTypes from 'prop-types'
import { kebabCase } from 'lodash'
import classnames from 'classnames/bind'
import styles from './styles.scss'
const cx = classnames.bind(styles)

const Ribbon = ({ children, containerClassName, color = 'gray', ...rest }) => {
  return (
    <div
      className={cx('container', containerClassName, kebabCase(color))}
      {...rest}
    >
      {children}
    </div>
  )
}

Ribbon.propTypes = {
  children: PropTypes.node,
  color: PropTypes.oneOf(['success', 'adcLightBlue', 'caution', 'gray']),
  containerClassName: PropTypes.string,
}

export default Ribbon
